import { Button } from "@mui/material"
import { Icons } from "../../../../../misc/Icons"
import { Theme } from "../../../../../misc/Theme"
import { store } from "../../../../../stores/Store"
import { AlertModal } from "../../../../.."
import AutomationNodeCreateForm from "../../../../form/automation/AutomationNodeCreateForm"
import { observer } from "mobx-react-lite"
import { Enquiry } from "../../../../../models/Enquiry"

interface EnquiryApplicationSectionProps {
    enquiry: Enquiry;
}

export default observer(function EnquiryApplicationSection ({enquiry}: EnquiryApplicationSectionProps) {

    var enquiryAutomations = store.NodeStore.getFolderChildren?.filter(an => an.enquiry?.uid === enquiry.uid)
    var possitiveOutcome = !!enquiry.childrenObjects.find(node => node.name === "STATUSES")?.childrenObjects.find(status => status.value === "Y")
    var automationOptions = store.AutomationStore.getQualifyingOnlineForms(enquiry)

    const openNewApplicationForm = () => {
        AlertModal({title: "Create Application", width: "600px", body: (
            <AutomationNodeCreateForm caseUid={enquiry?.parent?.uid} enquiryUid={enquiry.uid} />
        )})
    }

    return (
        <div className="detail-section">
            <div className="section-header">
                <div className="header">
                    <h4>Applications</h4>
                </div>

                <div className="section-subheader">
                    {enquiryAutomations?.length ? (
                        <h5>
                            Here are the Applications associated with this Enquiry. 
                            One Application per Enquiry should be enough but you can 
                            create more by <span className="link" onClick={() => openNewApplicationForm()}>clicking here</span>.</h5>
                    ) : null}

                    {!possitiveOutcome ? (
                        <h5>This Enquiry must reach a positive outcome before you can make an Application.</h5>
                    ) : null}

                    {possitiveOutcome && automationOptions?.length && !enquiryAutomations?.length ? (
                        <h5>Now that this enquiry has reached a positive outcome, you are able to make an Application.</h5>
                    ) : null}

                    {possitiveOutcome && !automationOptions?.length ? (
                        <h5>There are no Automation options for this Enquiry, you may need to proceed with your Application manually.</h5>
                    ) : null}
                </div>
                
                {enquiryAutomations?.map((an, i) => (
                    <div key={i} className="section-table" style={{marginBottom: "10px"}}>
                        <div className="section-row report-row">
                            <div className="section-cell">
                                <Icons.Application style={{color: Theme.palette.primary.main}} />
                            </div>

                            <div className="section-cell">
                                <span className="link" onClick={() => store.NodeStore.navigateNode(an.uid)}>
                                    {store.NodeStore.getDisplayName(an)}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}

                {possitiveOutcome && automationOptions?.length && !enquiryAutomations?.length ? (
                    <Button
                        color="success"
                        variant="contained" 
                        className="btn btn-md"
                        style={{margin: "8px"}} 
                        disabled={!!store.AppStore.sessionState}
                        onClick={() => openNewApplicationForm()}>
                        <Icons.Application /> Create Application
                    </Button>
                ) : null}
            </div>
        </div>
    )
})